(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Pop-UP-promo"] && !Shopify.designMode) return;
  try {
    
  class PromoPopup extends HTMLElement {
    connectedCallback() {
      this.closeButton = this.querySelector('.promo-popup__close');
      this.previouslyFocusedElement = null;
      this.closeButton.addEventListener('click', () => this.close());
      this.addEventListener('click', (event) => { if (event.target === this) this.close(); });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !this.hidden) this.close(); });
      this.querySelectorAll('[data-copy-code]').forEach((button) => button.addEventListener('click', () => this.copyCode(button)));
      if (this.dataset.repeat === 'once' && sessionStorage.getItem(this.dataset.storageKey)) return;
      window.setTimeout(() => this.open(), Number(this.dataset.delay) || 0);
    }

    open() {
      this.previouslyFocusedElement = document.activeElement;
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-visible'));
      document.body.style.overflow = 'hidden';
      this.closeButton.focus();
    }

    close() {
      this.classList.remove('is-visible');
      document.body.style.overflow = '';
      if (this.dataset.repeat === 'once') sessionStorage.setItem(this.dataset.storageKey, 'closed');
      window.setTimeout(() => { this.hidden = true; }, 300);
      this.previouslyFocusedElement?.focus();
    }

    async copyCode(button) {
      const status = button.closest('.promo-popup__offer').querySelector('.promo-popup__status');
      try {
        await navigator.clipboard.writeText(button.dataset.copyCode);
        button.textContent = 'Copié';
        status.textContent = 'Code copié';
      } catch (error) {
        status.textContent = `Code : ${button.dataset.copyCode}`;
      }
    }
  }

  if (!customElements.get('promo-popup')) customElements.define('promo-popup', PromoPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!window.cartPromotionCodeCopyBound) {
    window.cartPromotionCodeCopyBound = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-promotion-code]');

      if (!button) return;

      const code = button.dataset.promotionCode;
      let copied = false;

      try {
        await navigator.clipboard.writeText(code);
        copied = true;
      } catch (error) {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        copied = document.execCommand('copy');
        textarea.remove();
      }

      if (copied) {
        button.setAttribute('aria-label', `Code promo ${code} copié.`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
